import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  UncontrolledDropdown,
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  Row,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { DELETE, GET, POST, PUT } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import { NumericFormat } from "react-number-format";
import { useHistory, useLocation } from 'react-router-dom';
import { RSelect } from "../../components/Component";
import UpsertLocationDistance from "./UpsertLocationDistance";

const DEFAULT_LOCATION_DISTANCE = {
  fromLocation: "",
  fromLocationName: '',
  fromLocationAddress: '',
  toLocation: "",
  toLocationName: '',
  toLocationAddress: '',
  distance: 100,
};


const LocationDistanceManager = () => {
  const onSearchRef = useRef(null);
  const history = useHistory();
  const [data, setData] = useState([]);
  const [view, setView] = useState({
    edit: false,
    add: false,
    details: false,
    isDelete: false,
  });
  const { errors, register, handleSubmit, reset, getValues, control, setValue } = useForm({
    defaultValues: DEFAULT_LOCATION_DISTANCE,
  });
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [loading, setLoading] = useState(false);
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [fromLocationOptions, setFromLocationOptions] = useState([]);
  const [toLocationOptions, setToLocationOptions] = useState([]);


  const [filter, setFilter] = useState({
    fromLocation: searchParams.get('fromLocation') || "",
    toLocation: searchParams.get('toLocation') || "",
    distance: searchParams.get('distance') || "",
  });
  const colTable = [
    {
      Header: "Từ điểm(Mã)",
      accessor: "fromLocation",
    },
    {
      Header: "Từ điểm(Tên)",
      accessor: "fromLocationName",
    },
    {
      Header: "Địa chỉ điểm đi",
      accessor: "fromLocationAddress",
    },
    {
      Header: "Đến điểm(Mã)",
      accessor: "toLocation",
    },
    {
      Header: "Đến điểm(Tên)",
      accessor: "toLocationName",
    },
    {
      Header: "Địa chỉ điểm đến",
      accessor: "toLocationAddress",
    },
    {
      Header: "Khoảng cách(km)",
      accessor: "distance",
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onEditClick(item.id);
                        toggle("edit");
                      }}
                    >
                      <Icon name="edit" className="text-primary"></Icon>
                      <span>Sửa</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        onDuplicateClick(item.id);
                      }}
                    >
                      <Icon name="copy" className="text-primary"></Icon>
                      <span>Nhân bản</span>
                    </DropdownItem>
                  </li>
                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    GET("/location-distance", {}, true)
      .then((resp) => {
        const { data } = resp;
        const fromObj = {};
        const toObj = {};
        data.forEach((c) => {
          fromObj[c.fromLocation] = {
            fromLocation: c.fromLocation,
            fromLocationName: c.fromLocationName || c.fromLocation,
          };
          toObj[c.toLocation] = {
            toLocation: c.toLocation,
            toLocationName: c.toLocationName || c.toLocation,
          };
        });
        setFromLocationOptions(Object.values(fromObj).map((c) => ({
          label: c.fromLocationName,
          value: c.fromLocation,
          data: c,
        })));
        setToLocationOptions(Object.values(toObj).map((c) => ({
          label: c.toLocationName,
          value: c.toLocation,
          data: c,
        })));

      })
      .then(() => {
        GET("/location-distance/get-customer-internal-customer", {}, true).then((resp) => {
          const { data } = resp;
          if (data) {
            const { TL, CT } = data;
            setToLocationOptions((oldOptions) => {
              const existIds = {}
              oldOptions.forEach(e => existIds[e.value] = true);
              const newOptions = [...oldOptions];
              TL.forEach(c => {
                if (!existIds[c.id]) {
                  newOptions.push({
                    label: c.name,
                    value: c.id,
                    data: c,
                  })
                }
              })
              CT.forEach(c => {
                if (!existIds[c.id]) {
                  newOptions.push({
                    label: c.name,
                    value: c.id,
                    data: c,
                  })
                }
              })
              return newOptions;
            })
          }
        })
      })

  }, [timeNow]);
  // Changing state value when searching name
  useEffect(() => {
    clearTimeout(onSearchRef.current);
    onSearchRef.current = setTimeout(() => {
      const newParams = new URLSearchParams({
        ...(filter.fromLocation ? { fromLocation: filter.fromLocation } : {}),
        ...(filter.toLocation ? { toLocation: filter.toLocation } : {}),
        ...(filter.distance ? { distance: filter.distance } : {}),
      });
      history.replace({
        pathname: location.pathname,
        search: newParams.toString()
      })

      setLoading(true);
      setData([]);
      let params = {
        ...(filter.fromLocation ? { fromLocation: filter.fromLocation } : {}),
        ...(filter.toLocation ? { toLocation: filter.toLocation } : {}),
        ...(filter.distance ? { distance: filter.distance } : {}),
      };

      GET(`/location-distance`, params, true)
        .then(({ data }) => {
          setData(data);
        })
        .finally(() => {
          setLoading(false);
        });
    }, 600);
  }, [timeNow, filter]);


  // toggle function to view order details
  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const onEditClick = (id) => {
    setLoading(true);
    setEditedId(id);

    GET(`/location-distance/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onDuplicateClick = (id) => {
    setLoading(true);

    GET(`/location-distance/${id}`, {}, true)
      .then(({ data }) => {
        reset({
          ...data,
        });
        toggle("add");
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
        onFormCancel();

      })
      .finally(() => {
        setLoading(false);
      });
  };

  const resetData = () => {
    setEditedId("");
    onFormCancel();
    setTimeNow(moment().valueOf());
  };

  // Submits form data
  const onHandleSubmit = () => {
    setLoading(true);
    const { distance, fromLocation, toLocation, fromLocationName, toLocationName, fromLocationAddress, toLocationAddress } = getValues();

    const formData = {
      distance,
      fromLocation,
      fromLocationName,
      fromLocationAddress,
      toLocation,
      toLocationName,
      toLocationAddress,
    };

    const request = editId
      ? PUT(`/location-distance/${editId}`, formData, {}, true)
      : POST("/location-distance", formData, {}, true);

    request
      .then((res) => {
        if (editId) {
          toast.success("Cập nhật thành công");
        } else {
          toast.success("Thêm thành công");
        }
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    reset(DEFAULT_LOCATION_DISTANCE);
    setEditedId();
    setDeleteId();
  };

  const deleteOrder = (id) => {
    if (!id) {
      return;
    }
    DELETE(`/location-distance/${id}`, {}, true)
      .then((res) => {
        toast.success("Xóa khoảng cách tải thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý ngày lễ"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Khoảng cách tải</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Điểm đi"
                          value={filter.fromLocation}
                          onChange={(e) => {
                            setFilter({ ...filter, fromLocation: e.target.value || '' });
                          }}
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Điểm đến"
                          value={filter.toLocation}
                          onChange={(e) => {
                            setFilter({ ...filter, toLocation: e.target.value || '' });
                          }}
                        />
                      </div>
                    </li>
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <NumericFormat
                          placeholder="Khoảng cách"
                          className="form-control"
                          type="text"
                          value={filter.distance}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={0}
                          onValueChange={(values) => {
                            setFilter({ ...filter, distance: values?.floatValue || '' });
                          }}
                        />
                      </div>
                    </li>
                  </ul>
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div>
                        <Button
                          className="btn-primary"
                          color="primary"
                          onClick={() => {
                            resetData();
                            toggle("add");
                          }}
                        >
                          <Icon name="plus"></Icon>
                          <span>Thêm khoảng cách</span>
                        </Button>
                      </div>
                    </li>
                    <li>
                      <UpsertLocationDistance reload={resetData} />
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3">
                  <Table
                    columns={colTable}
                    data={data}
                    notShowPagi={true}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>

        <Modal
          isOpen={view.add || view.edit}
          toggle={() => onFormCancel()}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a href="#cancel" className="close">
              {" "}
              <Icon
                name="cross-sm"
                onClick={(ev) => {
                  ev.preventDefault();
                  onFormCancel();
                }}
              ></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">{editId ? "Sửa" : "Thêm"} khoảng cách</h5>
              <div className="mt-4">
                <form onSubmit={handleSubmit(onHandleSubmit)}>
                  <Row className="g-3">
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" >
                          Chọn điểm đi từ DS
                        </label>
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            options={fromLocationOptions}
                            onChange={(val) => {
                              if (val?.value) {
                                setValue("fromLocation", val.value);
                                setValue("fromLocationName", val.label);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Điểm đi(Mã) <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="fromLocation"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="fromLocation"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Điểm đi(Tên) <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="fromLocationName"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="fromLocationName"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="fromLocationAddress">
                          Địa chỉ điểm đi
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="fromLocationAddress"
                            ref={register()}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" >
                          Chọn điểm đến DS
                        </label>
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            options={toLocationOptions}
                            onChange={(val) => {
                              if (val?.value) {
                                setValue("toLocation", val.value);
                                setValue("toLocationName", val.label);
                              }
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Điểm đến(Mã) <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="toLocation"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="toLocation"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="6">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Điểm đến(Tên) <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="toLocationName"
                            ref={register({
                              required: "Vui lòng nhập thông tin",
                            })}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="toLocationName"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>
                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="toLocationAddress">
                          Địa chỉ điểm đến
                        </label>
                        <div className="form-control-wrap">
                          <input
                            type="text"
                            className="form-control"
                            name="toLocationAddress"
                            ref={register()}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col md="12">
                      <div className="form-group">
                        <label className="form-label" htmlFor="customer">
                          Khoảng cách <span className="text-danger">*</span>
                        </label>
                        <div className="form-control-wrap">
                          <Controller
                            control={control}
                            name="distance"
                            render={({ onChange, value, ref }) => (
                              <NumericFormat
                                className="form-control"
                                getInputRef={ref}
                                type="text"
                                value={value}
                                thousandsGroupStyle="thousand"
                                thousandSeparator=","
                                decimalScale={0}
                                onValueChange={(values) => {
                                  onChange(values.floatValue);
                                }}
                              />
                            )}
                          />
                          <ErrorMessage
                            errors={errors}
                            name="distance"
                            render={({ message }) => (
                              <span className="invalid">{message}</span>
                            )}
                          />
                        </div>
                      </div>
                    </Col>

                    <Col size="12">
                      <Button color="primary" type="submit">
                        <Icon className="plus"></Icon>
                        <span>{editId ? "Sửa" : "Thêm"} khoảng cách</span>
                      </Button>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <Modal isOpen={view.isDelete} toggle={() => onFormCancel()}>
          <ModalBody className="modal-body-lg text-center">
            <div className="nk-modal">
              <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-cross bg-danger"></Icon>
              <h4 className="nk-modal-title">
                Bạn có chắc muốn xoá ngày lễ này không ?{" "}
              </h4>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                  onClick={(ev) => {
                    ev.preventDefault();
                    deleteOrder(deleteId);
                  }}
                >
                  Xác nhận
                </Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default LocationDistanceManager;
